<template>
    <div>
        <vs-row v-if="cards">
            <vs-col  v-if="cards.total_alumnos" sm="12" lg="3" class="p-1">
                <div class="card md-warn">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{cards.total_alumnos}}</strong></h4>
                        <p class="mb-0"><strong>Total</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(info, key) in cards.niveles" :key="key">
                <div class="card md-green" v-if="cards.niveles">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{info}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Nivel Académico</small></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(info, key) in cards.programas" :key="key">
                <div class="card md-purple" v-if="cards.programas">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{info}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Programa</small></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(info, key) in cards.becas" :key="key">
                <div class="card md-blue" v-if="cards.becas">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{info}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Beca</small></p>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <vs-button
            v-if="users != ''"
            color="#55ce63"
            relief
            :loading="loadingExcel"
            @click="getExcel()"
            class="ml-auto"
        >
            <i class="fas fa-download mr-2"></i> Descargar reporte
        </vs-button>
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table striped>
            <template #thead>
            <vs-tr>
                <vs-th>
                    Alumno
                </vs-th>
                <vs-th>
                    Nivel Academico
                </vs-th>
                <vs-th>
                    Programa
                </vs-th>
                <vs-th>
                    Ciclo Escolar
                </vs-th>
                <vs-th>
                    Beca
                </vs-th>
                <vs-th>
                    Categoria
                </vs-th>
                <vs-th>
                    
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in $vs.getSearch(users, search)"
                :data="tr"
            >
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.persona_nombre }}</strong></p>
                    <p class="mb-0"><small>MATRÍCULA</small></p>
                    <p class="mb-0"><strong>{{ tr.persona_matricula }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.persona_nivel_academico }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.persona_programa }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.beca_ciclo }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.beca_nombre }}</strong></p><br>
                        <p   v-if="tr.status !== 'activa' ">Estatus : <strong style="color: red;">INACTIVA</strong></p>
                        <p  v-else>Estatus: <strong style="color: green;">ACTIVA</strong></p>
                    
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.categoria_nombre }}</strong></p>
                </vs-td>
                <vs-td>
                    <vs-button
                        success
                        flat
                        blank
                        :href="`/panel/`+ tr.url"
                    >
                        Ver perfil
                    </vs-button>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
        </vs-table>
    </div>
</template>

<script>
export default {
    props: [
        'users',
        'cards',
        'institucion',
        'grupo',
        'cicloEscolar'
    ],
    data(){
        return{
            loadingExcel: false,
            search: ''
        }
    },
    methods:{
        getExcel () {
            this.loadingExcel = true
            let formData = {
                'institucion_id': this.institucion,
                'grupo_id': this.grupo,
                'ciclo_escolar_id': this.cicloEscolar
            }

            formData.headers = ['persona_matricula', 'persona_nombre', 'persona_nivel_academico', 'persona_programa', 'beca_ciclo', 'beca_nombre', 'categoria_nombre']
            this.loading = true
            setTimeout(() => {
                axios.get('/reportes/file-becas', {
                    responseType: 'blob',
                    params: {...formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loading = false;
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
    }
}
</script>

<style lang="scss" scoped>

    .cien {
        width: 100px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .docientos {
        width: 200px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        justify-content: center;
        align-items: center;

    }
</style>

<style scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .md-warn{
        background: #ffbc34;
        color: white;
        border-radius: 7px;
    }

    .md-blue{
        background: #5DADE2;
        color: white;
        border-radius: 7px;
    }

    .md-green{
        background: #52BE80;
        color: white;
        border-radius: 7px;
    }

    .md-brown{
        background: #784212;
        color: white;
        border-radius: 7px;
    }

    .md-pruple{
        background: purple;
        color: white;
        border-radius: 7px;
    }
</style>